import Headroom from 'headroom.js';
import TouchDropdownToggle from "./touch-dropdown-toggle";
import MobileDropdownMenu from './mobile-menu-dropdown';

const HeaderNav = {
  _selectors: {
    headerNav: '.js-header-nav',
    menu: '.js-nav-menu',
    menuItemTopLevel: '.js-nav-menu-item-top-level',
    dropdownContainer: '.js-nav-menu-dropdown'
  },

  init() {
    const self = this;
    
    // Initialises Headroom.js
    const headroom = new Headroom(document.querySelector(this._selectors.headerNav), {
      tolerance : {
        // Gives a bit of margin when scrolling up before showing the menu
        up: 5,
        down: 10
      },
    });
    headroom.init();

    document
      .querySelector(this._selectors.menu)
      .querySelectorAll(this._selectors.menuItemTopLevel)
      .forEach(node => {

        if ( node.hasAttribute('data-has-children') ) {
          node.addEventListener('mouseenter', self.onDropdownAreaEnter.bind(self));
          node.addEventListener('mouseleave', self.onDropdownAreaLeave.bind(self));
        }
      });

    // Enables dropdown menu toggle on touch devices
    TouchDropdownToggle.init({
      onDropdownShow: (e) => {
        self.onDropdownAreaEnter(e);
      },
      onDropdownHide: (e) => {
        self.onDropdownAreaLeave(e);
      },
    });

    // Initialises Mobile Dropdown menu (for smaller breakpoints)
    MobileDropdownMenu.init();
  },

  onDropdownAreaEnter(e) {
    const dropdownEl = e.currentTarget.querySelector(this._selectors.dropdownContainer);
    if (this.isDropdownScrollRequired(dropdownEl)) {
      dropdownEl.style.overflow = 'auto';
      dropdownEl.style.height = (window.innerHeight - dropdownEl.offsetTop) + 'px';
    } else {
      dropdownEl.style.overflow = 'hidden';
      dropdownEl.style.height = 'auto';
    }
  },

  onDropdownAreaLeave(e) {
    const dropdownEl = e.currentTarget.querySelector(this._selectors.dropdownContainer);
    dropdownEl.style.overflow = 'hidden';
    dropdownEl.style.height = 'auto';
  },

  isDropdownScrollRequired(dropdownEl) {
    const bottomPos = dropdownEl.offsetTop + dropdownEl.offsetHeight;
    return bottomPos > window.innerHeight;
  }
};

export default HeaderNav;